import { defineStore } from "pinia";
import axios, { ResponseType } from "@/utils/request";

export interface CityListItem {
  id: number;
  nameCn: string;
  nameHk: string;
  nameEn: string;
  cityName: string;
  code: string;
  state: number;
  enableFlag: number;
  disable: boolean;
}

export interface MapInfo {
  [key: string]: any;
}

export interface CityState {
  cityList: CityListItem[]; // 全部城市列表
  cityMap: MapInfo; // 城市id=>名称
  cityValue: string; // 城市关键字搜索
  needReflash: boolean; // 查询条件 + 页码重制， 页面刷新
  reflashNum: number; // 点击菜单刷新开关
  tablePageReflash: boolean; // 查询条件不重置 +  页码重制， 页面刷新
  agentWhiteListRow: object; //代理白名单列表的详情数据
  agentApiListRow: object; //代理Api账号列表的详情数据
}

interface CityGetters {
  cityOption: CityListItem[];
}
let agentWhiteListRow: CityState["agentWhiteListRow"] = {};
try {
  const o = sessionStorage.getItem("agent_white_row");
  if (o) {
    agentWhiteListRow = JSON.parse(o);
  }
} catch (error) {
  console.log(error);
}

let agentApiListRow: CityState["agentApiListRow"] = {};
try {
  const o = sessionStorage.getItem("agent_api_row");
  if (o) {
    agentApiListRow = JSON.parse(o);
  }
} catch (error) {
  console.log(error);
}

export const useCityStore = defineStore({
  id: "cityList",
  state: (): CityState => ({
    cityList: [],
    cityMap: {},
    cityValue: "",
    needReflash: true,
    reflashNum: 0,
    tablePageReflash: false,
    agentWhiteListRow: agentWhiteListRow,
    agentApiListRow: agentApiListRow,
  }),
  getters: {
    cityOption(state): CityGetters["cityOption"] {
      const newValue = state.cityValue.toLowerCase().trim();

      if (!newValue) {
        return state.cityList; // 重制回allList
      } else {
        return state.cityList.filter(
          (item) =>
            item.nameCn.includes(newValue) ||
            item.nameHk.includes(newValue) ||
            item.nameEn.toLowerCase().includes(newValue)
        );
      }
    },
    getAgentWhiteListRow(state): any {
      return state.agentWhiteListRow;
    },
    getAgentApiListRow(state): any {
      return state.agentApiListRow;
    },
  },
  actions: {
    async getCityList(): Promise<void> {
      const res: ResponseType = await axios.get(
        "/facade/sale/line/city/selectListCity"
      ); // 票务用这个城市接口
      // const res = await axios.get("/facade/sale/base/cities"); // 只有售票城市是用这个接口，别弄错了
      if (res.code === 0) {
        this.updateAllCityList(res.data);
      }
    },
    updateAllCityList(list: CityListItem[]): void {
      this.cityList = list;
      list.map(({ id, nameCn }) => {
        this.cityMap[`${id}`] = nameCn;
      });
    },
    updateCityValue(value: string): void {
      this.cityValue = value;
    },
    updateNeedReflash(value: boolean): void {
      this.needReflash = value;
    },
    updateReflashNum(): void {
      this.reflashNum++;
    },
    updateTablePageReflash(value: boolean): void {
      this.tablePageReflash = value;
    },
    updateAgentWhiteListRow(row: CityState["agentWhiteListRow"]): void {
      this.agentWhiteListRow = row;
      try {
        sessionStorage.setItem(
          "agent_white_row",
          JSON.stringify(this.agentWhiteListRow)
        );
        // eslint-disable-next-line no-empty
      } catch (error) {}
    },
    updateAgentApiListRow(row: CityState["agentApiListRow"]): void {
      this.agentApiListRow = row;
      try {
        sessionStorage.setItem(
          "agent_api_row",
          JSON.stringify(this.agentApiListRow)
        );
        // eslint-disable-next-line no-empty
      } catch (error) {}
    },
  },
});
